import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AbstractMatTable} from '../../../shared/classes/mat-table/abstract-mat-table';
import {DashboardService} from '../../../shared/services/dashboard/dashboard.service';
import {IconService} from '../../../shared/services/icon/icon.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../shared/services/state/states.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-dashboard-edas',
  templateUrl: './dashboard-edas.component.html',
  styleUrls: ['./dashboard-edas.component.scss']
})
export class DashboardEdasComponent extends AbstractMatTable implements OnInit, OnDestroy {

  readonly MAIN_COLUMNS_TO_DISPLAY = ['note', 'project', 'projectName', 'projectCode', 'spcu', 'spcuName'];
  readonly DETAILS_COLUMNS_TO_DISPLAY = ['dataConsumption', 'pingRouter', 'pingEdas', 'timeGap', 'senorLastMeasure', 'channelInversion', 'outOfRange', 'dynFlags', 'acquisitionMalfunction'];
  public levelSubscription: Subscription;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private dashboardService: DashboardService,
              public iconService: IconService,
              private translate: TranslateService,
              private statesService: StatesService) {
    super();
  }


  ngOnInit(): void {
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getEdasDashboardByCurrentLevel()
      );
    this.getEdasDashboardByCurrentLevel();
  }

  ngOnDestroy(): void {
    this.levelSubscription.unsubscribe();
  }

  getClassByNote(note: any): string {
    note = parseInt(note);
    let classNote = 'green';
    if (note === 0) {
      classNote = 'red';
    }
    if (note === 1) {
      classNote = 'orange';
    }
    return classNote;
  }

  getClassByElementName(name: string): string {
    let className = '';
    if (name === 'projectName' || name === 'projectCode') {
      className = 'detail1';
    }
    if (name === 'spcuName') {
      className = 'detail2';
    }
    return className;
  }

  getIconStatus(note: any) {
    note = parseInt(note);
    let icon = this.iconService.faSmile;
    if (note === 0) {
      icon = this.iconService.faSadTear;
    }
    if (note === 1) {
      icon = this.iconService.faFrown;
    }
    return icon;
  }

  private getEdasDashboardByCurrentLevel() {
    this.setMatTable(this.dashboardService.getDashboardEdasForCurrentLevel(), this.MAIN_COLUMNS_TO_DISPLAY.concat(this.DETAILS_COLUMNS_TO_DISPLAY));
  }

}
